// extracted by mini-css-extract-plugin
module.exports = {"countdown":"wh-z","srOnly":"xh-z"};